/* eslint-disable max-len */
import BtcQuestion from 'images/coin-pages/questions/btc.svg'

import { ECoinPageParagraphTypes, ICoinPageData } from '../types'

export const btcPage: ICoinPageData = {
  title: 'coin_210',
  description: 'coin_211',
  // description:
  //   'Get a Bitcoin loan. Receive up to 90% of your BTC loan collateral in cash or crypto and continue holding. Borrow bitcoin instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, locale, replacePlaceholders) => (
    <>
      <span
        dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Bitcoin' }) }}
      />
      {locale === 'en' && ` - ${t('lend')} BTC`}
    </>
  ),
  questionsBlock: {
    image: BtcQuestion,
    questions: [
      {
        title: 'coin_212',
        answer: 'coin_213',
      },
      {
        title: 'coin_214',
        answer: 'coin_215',
      },
      {
        title: 'coin_216',
        answer: 'coin_217',
      },
      {
        title: 'coin_218',
        answer: 'coin_219',
      },
      {
        title: 'coin_220',
        answer: 'coin_221',
      },
    ],
  },
  whatIs: {
    text: [],
    paragraphs: [
      {
        title: 'coin_222',
        text: ['coin_226'],
      },
      {
        title: 'coin_223',
        text: ['coin_227', 'coin_228', 'coin_229', 'coin_230'],
        type: ECoinPageParagraphTypes.ul,
      },
      {
        title: 'coin_224',
        text: ['coin_231', 'coin_232', 'coin_233', 'coin_234'],
        type: ECoinPageParagraphTypes.ul,
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-a-bitcoin-loan-get-your-btc-loan-on-coinrabbit/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1014/https://coinrabbit.io/blog/wp-content/uploads/2021/07/Screenshot_1145.png',
        imageAlt: 'Bitcoin (BTC) Cryptocurrency review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Bitcoin (BTC) Cryptocurrency review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
        imageAlt: 'Bitcoin (BTC) Cryptocurrency review 7',
      },
    ],
  },
  videoId: 'mTn4jzA5YaY',
  videoTitle: 'coin_225',
}
